import ScratchCommunication from '~/pages/communication/scratch/libs/components/ScratchCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const ScratchCommunicationPage = (props: TPageProps) => (
  <ScratchCommunication {...props} />
)

export default ScratchCommunicationPage
